import { gql } from 'graphql-request'
import { request } from './core/utils/request'

const GerarPushSubscriptionGql = gql`
  mutation GerarPushSubscription($input: PushSubscriptionInput!) {
    gerarPushSubscription(pushSubscriptionInput: $input)
  }
`

export const register = async vapidPublicKey => {
  const isServiceWorker = 'serviceWorker' in navigator
  const isNotification = 'Notification' in window
  const isEdge = navigator.userAgent.indexOf('Edge') > -1

  if (isServiceWorker && isNotification && !isEdge) {
    await navigator.serviceWorker.register(`/sw-portal.js`)
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      registerSubscription(vapidPublicKey)
    }
  }
}

const registerSubscription = async vapidPublicKey => {
  const registration = await navigator.serviceWorker.ready

  if (registration == null || registration.pushManager == null) {
    return
  }
  let subscription = await registration.pushManager.getSubscription()
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidPublicKey
    })
  }
  generateSubscription(subscription.toJSON())
}

const generateSubscription = subscription => {
  request(GerarPushSubscriptionGql, {
    variables: {
      input: {
        endpoint: subscription.endpoint,
        auth: subscription.keys.auth,
        key: subscription.keys.p256dh
      }
    }
  })
}
